import { FormInput } from "@general-backoffice/core";
import React, { useMemo } from "react";

import { buildGroupedReferrerTypeOptions, TAX_REFERRER_TYPES } from "../taxProfileConstants";

interface TypeStepProps {
  taxProfile: Record<string, unknown> | null;
  handleInputChange: (name: string, value: unknown) => void;
  isLoading: boolean;
  t: (key: string, fallback?: string) => string;
}

const TypeStep = ({ taxProfile, handleInputChange, isLoading, t }: TypeStepProps) => {
  const groupedOptions = useMemo(() => buildGroupedReferrerTypeOptions(t), [t]);

  // Flat options list for finding selected value
  const flatOptions = useMemo(
    () =>
      TAX_REFERRER_TYPES.map((type) => ({
        value: type.value,
        label: t(`referrerTypes.${type.value}`, type.value.replace(/_/g, " ")),
      })),
    [t]
  );

  const selectedType = flatOptions.find((o) => o.value === taxProfile?.profileType);

  return (
    <div>
      <h5 className="mb-3">{t("steps.type.title", "Select Your Type")}</h5>
      <p className="text-muted mb-4">
        {t("steps.type.description", "Please select the type that best describes your tax situation.")}
      </p>

      <FormInput.Select
        label={t("steps.type.label", "Referrer Type")}
        name="profileType"
        value={selectedType}
        options={groupedOptions}
        onChange={({ value }) => handleInputChange("profileType", value)}
        isDisabled={isLoading}
        placeholder={t("steps.type.placeholder", "Select a type...")}
      />
    </div>
  );
};

export default TypeStep;
